<template>
    <anonymous-app v-if="isAnonymous" />
    <template v-else>
        <winck-app v-if="!hasAskNoaBranding()" />
        <ask-noa-app v-if="hasAskNoaBranding()" />
    </template>
</template>

<script setup lang="ts">
    import { computed, watch } from 'vue';
    import AnonymousApp from '@/shared/components/app/AnonymousApp.vue';
    import WinckApp from '@/shared/components/app/WinckApp.vue';
    import AskNoaApp from '@/shared/components/app/AskNoaApp.vue';
    import useAppBranding from '@/services/app-branding/composables/useAppBranding';
    import { useI18n } from 'vue-i18n';
    import { useRouter } from 'vue-router';

    const router = useRouter();
    const { hasAskNoaBranding } = useAppBranding();
    const { mergeLocaleMessage, locale } = useI18n();

    if (hasAskNoaBranding()) {
        mergeLocaleMessage('nl', {
            application: {
                name: 'AskNoa',
            },
            domain: {
                brand: 'Website',
                brand_inline: 'De @.lower:domain.brand',
                brands: 'Websites',
                brands_inline: 'De @.lower:domain.brands',
            },
        });

        mergeLocaleMessage('en', {
            application: {
                name: 'AskNoa',
            },
            domain: {
                brand: 'Website',
                brand_inline: 'The @.lower:domain.brand',
                brands: 'Websites',
                brands_inline: 'The @.lower:domain.brands',
            },
        });
    }

    const isAnonymous = computed(() => {
        return router.currentRoute.value.meta.anonymous;
    });

    watch(locale, (value) => {
        document.documentElement.lang = value;
    }, { immediate: true });
</script>

<style lang="scss">
body.branding--WINCK {
    #app,
    #sidesheets,
    #dialogs,
    #collapses,
    #interaction-blockers,
    #notifications,
    #tooltips {
        font-family: 'Nunito Sans', sans-serif;

        h1, h2, h3, h4, h5, h6 {
            font-family: 'PT Sans', sans-serif;
        }
    }
}

body.branding--ASK_NOA {
    #app,
    #sidesheets,
    #dialogs,
    #collapses,
    #interaction-blockers,
    #notifications,
    #tooltips {
        font-family: 'Roboto', sans-serif;
    }
}

html, body, #app {
    height: 100%;
    overflow: hidden;
    line-height: unset;
}

section {
    width: 100%;
}

a {
    text-decoration: none;
}

button {
    cursor: pointer;
}

#warnings > *:last-child {
    margin-bottom: size(lg);
}
</style>
